export const DsTypographyDefaultProps = {
    variant: 'bodyRegularMedium'
};
